import React, { Component } from 'react'
import './TermsAndConditions.scss'

export default class BrokerTermsAndConditions extends Component {
  constructor(props) {
    super(props)

    this.state = {
      privacyPolicyLink: 'https://www.opcity.com/privacy-policy/',
      participationAgreementLink: 'https://www.realtor.com/privacy-policy/',
    }
  }

  render() {
    return (
      <div className="BrokerTermsAndConditions">
        <div className="BrokerTermsAndConditions__header">
          <h1>NETWORK TERMS AND CONDITIONS</h1>
          <h3>Real Estate Brokerages and Firms</h3>
        </div>
        <div className="BrokerTermsAndConditions__frame">
          <div className="BrokerTermsAndConditions__last-updated">
            Last Updated: January 21, 2025
          </div>
          <div>
            <p>
              By using or accessing realtor.com, the Referral platform, or any mobile application for such
              Products or portals (each referred to herein as the &quot;<strong>Product</strong>&quot;), you acknowledge and agree that
              you are subject to the following terms and conditions, as well as our <a href={this.state.privacyPolicyLink} target="_newtab">Privacy Policy</a> , which also
              governs your use of the Product, and is incorporated by reference (These Terms and Conditions
              with the Privacy Policy along with your Participation <a href={this.state.participationAgreementLink} target="_newtab">Agreement</a> and/or Broker Lead Accelerator
              Agreement and any Referral Agreements shall be referred to as the &quot;<strong>Terms</strong>&quot;). Please read
              these Terms carefully, as they contain important information about limitations of liability
              and resolution of disputes through arbitration rather than court.
            </p>

            <p>
              If you do not fully agree to these Terms and any other terms and conditions posted or linked to
              any Product, you are not authorized to access or otherwise use the Product. Under these
              Terms, &quot;<strong>use</strong>&quot; or &quot;<strong>access</strong>&quot; of the Product specifically includes any direct or indirect access or use
              of the Product or any cached version of the Product. The Product is operated by MSIMove
              Sales, Inc. (realtor.com).  Unless otherwise specified, the entity controlling the Product you are
              accessing is referred to herein as &quot;<strong>Move Sales, Inc.,</strong>&quot; &quot;<strong>MSI,</strong>&quot; &quot;<strong>realtor.com,</strong>&quot; &quot;<strong>we,</strong>&quot; &quot;<strong>us</strong>&quot; or
              &quot;<strong>our</strong>&quot;. We may refer to you, the Broker, as &quot;<strong>Broker</strong>&quot;, &quot;<strong>you</strong>&quot; or a &quot;<strong>user</strong>&quot; of the Product.
            </p>

            <p>
              You have all necessary right, power and authority and have taken all necessary action to enter
              into and perform its services in accordance with these Terms. Your entering into these Terms will
              not violate or conflict with the rights of any third party or with any service, employment,
              confidentiality, consulting or other agreement to which you may be bound.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">1.</span>Other Definitions.</strong></p>

            <p>
              &quot;<strong><u>Agent</u></strong>&quot; means an appropriately licensed current or former
              employee or independent contractor of Broker who may work with a real estate Referral as part of
              the Concierge Referral Network (the “Network”). Any reference to an Agent obligation in this
              Agreement is also binding on you. You and the Agent are jointly and severally responsible for the
              Service Fees. You represent that you will educate your Agents on the obligations set forth in these Terms.
            </p>

            <p>
              &quot;<strong><u>Gross Commission</u></strong>&quot; is defined as the amount that the Broker is eligible to receive as stated in the closing
              document including any fees and bonuses paid to you or an Agent. Gross Commission does not take into
              account any discounts or commission reduction you or an Agent may extend to a Referral; it is not the
              commission that you or an Agent actually receive. Gross Commission does exclude any commissions
              for other real estate settlement services such as title insurance.
            </p>

            <p>
              &quot;<strong><u>Referral</u></strong>&quot; means a consumer that is interested in real estate and is referred by MSI to
              you and your Agents for the purpose of a real estate transaction. <strong>Referral also includes
                any consumer(s) that is referred by the Referral to you and your Agents, in connection with
                the initial services provided by MSI, for the purpose of a real estate transaction during the
                Referral Coverage Period (as later defined)</strong>.
            </p>

            <p>Other capitalized terms that are specifically defined herein shall be ascribed the same definitions
              whenever those capitalized terms are used in this Agreement.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">2.</span>The Product is a Service and We are Not a Party to any Transaction Between You, an Agent and/or Consumers.</strong></p>

            <p>
              We are not a party to any rental, purchase or other agreement between you and consumers. This is
              true even if the Product allows you to interact with consumers, set appointment times, and track
              transaction progress. As a result, any part of an actual or potential transaction between you and
              a consumer, including the quality, condition, safety or legality of a property, the truth or
              accuracy of a listing, are solely the responsibility of each user. You understand and acknowledge
              that we do not run criminal background checks on Referrals. We do not pre-screen Referrals in any
              way for criminal history and encourage you to conduct your business and prospecting activities in
              a safe manner.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">3.</span>Network Participation Requirements; Use of Broker’s Trademark.</strong></p>

            <p>You and your designated Agents shall participate in the Network on a non-exclusive basis for the
              purpose of assisting Referrals with real estate transactions.  You and your Agents agree to
              provide Referrals with services which may include:
              <ul>
                <li>Placing a Referral’s home on the multiple listing service and/or other listing databases in which you and/or your Agents participate.</li>
                <li>Helping Referrals find a suitable property to purchase or lease.</li>
                <li>Helping Referrals to sell property. </li>
              </ul>
            </p>

            <p>By participating in the Network and accepting Referrals, you and/or your Agents agree to:
              <ul>
                <li>Charge a reasonable real estate brokerage fee for the particular geographic area;</li>
                <li>Provide the Referral with any disclosures that are required by law including, if
                  necessary, the fact that you are paying a Service Fee to MSI if the Referral
                  completes and funds a real estate transaction; and</li>
                <li>
                  Maintain the confidentiality of the Referral’s information whether provided by
                  MSI or the Referral a) to the extent required by Title V, Subtitle A of the Gramm-Leach-Bliley
                  Act, 15 U.S.C. §§ 6801 et seq. and any of its amendments; b) to the extent required by any other
                  law or regulation; and c) to the extent required by MSI’s <a href={this.state.privacyPolicyLink} target="_newtab"> Privacy Policy</a>.MSI
                </li>
              </ul>
            </p>
            <p>
              You understand and agree that you, through your Agents, will be the only party to provide brokerage
              services to the Referrals and MSI will not provide any such services. MSI’s responsibility is to
              provide you and your Agents with contact and any other information it obtains about the Referral
              and to monitor your and your Agents’ delivery of brokerage services to those Referrals. You
              understand that MSI does not have any responsibility to provide brokerage services to Referrals.
            </p>

            <p>
              As a Network participant, you and your Agents may receive access to certain Referrals with the
              understanding that, because of its proprietary matching algorithm, MSI cannot make any guarantees
              regarding the number of Referrals, the quality of Referrals, or the frequency of Referrals that
              you and your Agents may receive.
            </p>

            <p>
              You and your Agents acknowledge and agree that the satisfaction of Referrals is an integral part
              of the success of the Network. As such, it is important that you and your Agents keep MSI
              informed about the current status of all Referrals and quickly investigate any cause of Referral
              dissatisfaction. If a Referral determines that you and/or your Agents are unable to provide
              satisfactory service, then you and/or your Agents shall notify MSI immediately. MSI may ask you
              and/or your Agents to stop working with the Referral or request other reasonable actions on the
              part of the you and/or your Agents to ensure Referral satisfaction. In the event you and/or your
              Agents transfer the Referral to another broker or agent on its own volition, the relevant Service
              Fees will still be owed as further explained below.
            </p>

            <p>
              You and your Agents shall keep MSI updated on the status of the Referral’s real estate transaction
              by submitting Referral comments at least as frequent as every seven (7) days in the Product.
              This reporting will include information that helps MSI track initial Referral contact, information
              regarding pending offers, accepted contracts, and closing data. Upon closing a real estate transaction
              with a Referral, you and your Agents agree to provide MSI with the closing statement no later than
              fifteen (15) days following the close.
            </p>

            <p>
              You grant to MSI a limited, non-exclusive, royalty-free, worldwide, fully paid up license to use
              Broker’s name, logo and tradename solely to identify Broker as a MSI customer. You represent and
              warrant that the use of Broker name, logo and trademark does not and will not violate or infringe
              upon any patent, copyright, privacy, publicity, trademark, service mark, or any other intellectual
              property right of any third party.
            </p>

            <p>You agree to provide disclosures (in the form we provide) to any third party upon our request.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">4.</span>Referral Ownership.</strong></p>

            <p>
              MSI owns all right, title, and interest (including, without limitation, all copyrights,
              trade secrets, patents, trademarks, and any other intellectual property or proprietary rights)
              in and to any Referrals. As part of its participation in the Network, MSI agrees to try and connect
              you and your Agents with Referrals to determine if real estate services can be provided. As the
              owner of the Referrals, MSI retains the right to use the Referrals and Referral data as it deems
              fit including copying, licensing, sublicensing (through multiple tiers), adapting, distributing,
              displaying, reproducing, transmitting, modifying, selling, contacting and editing the Referrals.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">5.</span>Referral Acceptance.</strong></p>

            <p>
              When MSI informs you and or your Agents that a Referral is available, your Agents will be given the opportunity to accept or decline the Referral.
              You acknowledge and affirm that the Agent has authority to accept a Referral on your behalf.
              If an Agent accepts the Referral, MSI will issue a Referral Agreement (the &quot;<strong><u>Referral Agreement</u></strong>&quot;).
              You and/or an Agent will have forty-eight (48) hours from acceptance of a Referral to notify MSI if it is duplicative with an existing client
              or if you do not agree to the Service Fee outlined in the Referral Agreement and subsequently reject the Referral.
              Following the expiration of the forty-eight-hour period, the Referral will be deemed accepted by you and
              the applicable Agent (the &quot;<strong><u>Referral Acceptance Date</u></strong>&quot;).
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">6.</span>Limited License to Use the Product.</strong></p>

            <p>
              Users are granted a limited, revocable non-exclusive license to access the Product and the
              content and services provided on the Product solely for the purpose of accepting leads, tracking
              leads, communicating with MSI and/or leads, and other related services as permitted by MSI and
              in accordance with the Terms. Any use of the Product that is not for one of these purposes or
              otherwise in accordance with the Terms or as otherwise authorized by us in writing is expressly
              prohibited.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">7.</span>Unauthorized Uses of the Product.</strong></p>

            <p>The license to use the Product only extends to the uses expressly described herein.
              The license to use the Product granted to users in these Terms does not include any right of collection, aggregation, copying, scraping, duplication,
              display or any derivative use of the Product nor any right of use of data mining, robots, spiders or similar data gathering and extraction tools
              without our prior written permission.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">8.</span>Unauthorized Uses of the Product.</strong></p>

            <p>The Product and all content and information on the Product are protected by copyright as a collective work and/or compilation,
              under applicable U.S. and international copyright laws and conventions and database rights. You agree to abide by any and all
              copyright notices, information or restrictions contained in or relating to any content on the Product. Copying, storing or
              otherwise accessing the Product or any content on the Product other than for your personal, noncommercial use (other than in
              accordance with a valid listing) is expressly prohibited without prior written permission from us. As part of tracking a real
              estate transaction, you may download, display and/or print one copy of any portion of the Product.
              You may not modify the same, and you must reproduce our copyright notice in the form displayed on the relevant portion(s) of the
              Product that you desire to download, display or print.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">9.</span>Software Available in the Product.</strong></p>

            <p>
              The Product is controlled and operated by MSI or an affiliate of MSI in the United States.
              Software available in the Product the &quot;<strong>Software</strong>&quot;) is subject to United States export controls.
              No Software available in the Product or software available may be downloaded or otherwise
              exported or re-exported (i) into (or to a resident of) Cuba, Iraq, Libya, North Korea, Iran,
              Syria or any other country to which the United States has embargoed goods, or (ii) anyone on the
              United States Treasury Department’s list of Specially Designated Nationals or the United States
              Commerce Department’s Table of Deny Orders. By using the Product, you represent and warrant that
              you are not located in, under the control of, or a national or resident of any such country or on
              any such list.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">10.</span>Service Fees.</strong></p>

            <p>
              <strong>
                You agree to pay MSI a percentage of the Gross Commissions (the “Service Fees”) for
                client-side real estate brokerage services and real estate agency services on any and all real
                estate transactions (including leases and subsequent lease commissions on a property sold)
                involving the Referral for a period of twenty-four (24) months following the Referral
                (the “Referral Coverage Period”). The specific Service Fee charged will be up to 40% depending
                upon the type of lead and any promotional programs currently in effect at the time of the
                Referral.  Said Service Fee will be specified in each Cooperative Brokerage Referral Agreement.
              </strong>
            </p>

            <p>
              The Service Fees owed to MSI are not impacted, reduced or waived due to any other referral, fee,
              commission or other payment that you or an Agent may owe to another third party based on a
              Referral’s real estate transaction.
            </p>

            <p>
              You agree that all Service Fees will be paid within fifteen (15) days of transaction closing
              and funding by a company check, ACH or wire transfer.  If you are an MSI Broker Lead Accelerator
              client, and you are delinquent in paying either the Monthly Accelerator Fee or MSI Service Fees
              owed as part of that product, MSI reserves the right to no longer send Referrals
              to you regardless of whether you may be current on any Service Fees owed outside of the Broker
              Lead Accelerator product.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">11.</span>Transfer of Referrals; Transfer of Agents.</strong></p>

            <p>
              Should you or an Agent transfer the Referral to another broker or agent and should that
              broker, or agent, enter into any real estate transaction with the Referral during the Referral
              Coverage Period, you shall pay to MSI the respective Service Fee as if you and/or you Agent had
              directly participated in the real estate transaction.
            </p>

            <p>
              <strong>
                The Service Fees are tied to the Referral. The obligation for you to pay Service Fees under
                these Terms is not subject to an Agent’s continued employment or contractor relationship with
                you and is not waived, forgiven, or nullified upon the termination of such relationship.
                Should an Agent enter into a real estate transaction with a Referral during the Referral
                Coverage Period, you and the Agent will be jointly and severally responsible for the
                respective Services Fees attached to that Referral.
              </strong>
            </p>

            <p>
              <strong>
                If you create a new brokerage and take a Referral with you to your new brokerage, you still
                owe us the Service Fees. If you sponsor or transfer an Agent from another Network brokerage
                to your brokerage, you agree to be responsible for payment of Service Fees to MSI for
                Referrals to said Agent prior to joining your brokerage.
              </strong>
            </p>

            <p>You affirm that you understand your obligations as set forth in this Section 11.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">12.</span>Confidentiality.</strong></p>

            <p>Each party will maintain the confidentiality of any information that is received from the other party and
              is confidential (&quot;<strong>Confidential Information</strong>&quot;).</p>

            <p>Confidential Information includes, without limitation, (a) the information constituting the Referral,
              including nonpublic personal information of any consumer, (b) other information that is subject to privacy
              or confidentiality restrictions under Title V, Subtitle A of the Gramm-Leach-Bliley Act, 15 U.S.C. §§ 6801 et seq. and any of its amendments;
              (c) other information that is subject to privacy or confidentiality restrictions to under any other law or regulation;
              (d) other information that is subject to privacy or confidentiality restrictions under a party’s privacy policy;
              and (e) nonpublic information that (i) a party designates as being confidential
              (ii) under the circumstances surrounding disclosure should be treated as confidential, or
              (iii) by reason of its nature would be treated as confidential by a reasonable person.</p>

            <p>Confidential Information includes, without limitation, information in tangible or intangible form relating
              to and/or including a party's business policies, trade secrets or practices, financial data, customer data,
              and information received from third parties that a party is obligated to treat as confidential.</p>

            <p>Neither party shall use the other party’s Confidential Information except as permitted by these Terms.
              Each party shall hold the other party’s Confidential Information in confidence, and shall not disclose
              such Confidential Information to any persons other than those employees and/or agents who have a
              business-related need to have access to such Confidential Information in furtherance of the limited purposes
              of these Terms and who have been apprised of, and agree in writing to maintain, the confidential nature of
              such information in accordance with these Terms. Each party shall be responsible for the breach of this
              Agreement by any of its employees and/or agents.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">13.</span>Your E-mail Address, Phone Number and Data; Our Privacy Policy; Data Transmittal.</strong></p>

            <p>
              When you provide your e-mail address, phone number, name or other information to us in
              connection with your use or access to the Product, any service or tool provided in the Product
              or otherwise, you agree to allow the MSI to add your e-mail address, phone number,
              name or other information provided to our database of users. You may receive one or more
              promotional e-mails from either MSI or MSI affiliates.
              You are welcome to opt not to receive such promotional e-mails from the Product or such
              affiliates’ services at any time.
            </p>

            <p>
              By providing your mobile phone number, you consent to receive text messages from MSI sent by
              an automatic telephone dialing system. Text messages will include referrals but also product
              updates, training and educational materials, and other information that MSI believes to be
              ancillary to your participation in the MSI network. You understand that message and data
              rates may apply. You can respond STOP to cancel marketing text messages. Text messages with
              referral information are considered transactional; opting out of the MSI Network is the only
              way that you can cancel transactional text messages.
            </p>

            <p>Please review our <a href={this.state.privacyPolicyLink} target="_newtab">Privacy Policy</a>, for more information regarding our email
              and other data collection practices and safeguards, and how to opt not to receive such emails. Your use of the Product signifies your acknowledgment of,
              and agreement with, our <a href={this.state.privacyPolicyLink} target="_newtab">Privacy Policy</a>. We adhere to strong principles of privacy.
              You agree that we may access and use your user-contributed content in accordance with these Terms or
              our <a href={this.state.privacyPolicyLink} target="_newtab">Privacy Policy</a>, and we agree that we will only disclose your user-contributed content in
              accordance with these Terms and our <a href={this.state.privacyPolicyLink} target="_newtab">Privacy Policy</a>.</p>

            <p>
              To the extent applicable for the activities contemplated under these Terms, you will comply with
              all privacy and security laws to which it is subject, and will not, by act or omission, place
              MSI in violation of any applicable privacy or security law. You represent that your
              brokerage’s privacy policy is consistent with, and in any case no less stringent than,
              MSI’s Privacy Policy, particularly regarding the use and protection of data.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">14.</span>
              Limitations on Communications and Use of Other Users’ Information; No Spam.</strong></p>

            <p>You agree that, with respect to other users&apos; personal information that you obtain directly or indirectly from or through the
              Product or through any Product-related communication, transaction or software, we have granted to you a license to use such information only for:
              (i) Product-related communications that are not unsolicited commercial messages, (ii) using services offered through the Product,
              and (iii) inquiring about a transaction between you and the other user related to the purpose of the Product.
              Any other purpose will require express permission from the user. You may not use any such information for any
              unlawful purpose or with any unlawful intent.</p>

            <p>We do not tolerate spam or unsolicited commercial electronic communications of any kind. Therefore, without limiting the foregoing,
              you are not licensed to add a Product user, even a user who has used your services, to your mailing list (email or physical mail)
              without the user's express consent. You may not use any tool or service on the Product to send spam or unsolicited commercial electronic communications
              of any kind or in any other way that would violate these Terms.</p>

            <p>
              Notwithstanding any other language herein, unless otherwise mutually agreed in writing: (1) it
              is your sole responsibility to ensure that you have obtained all necessary consents under any
              applicable laws or regulations that apply to texts, phone calls, or other forms of communication,
              use of automated technologies or artificial or prerecorded voice or artificial intelligence
              technologies and (2) we do not represent or warrant that the consumer information we provide
              you with as part of any product or otherwise will comply with consent requirements under the
              TCPA or other applicable laws or regulations governing communications. You represent and warrant
              that any communications you engage in with consumer information obtained from us will be compliant
              with all applicable laws and regulations.  We are in no way responsible for any noncompliant
              communications by anyone to whom we provide a consumer’s contact information.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">15.</span>Unsolicited Ideas and Feedback.</strong></p>

            <p>
              From time to time, users submit to us ideas or suggestions pertaining to our business, such as
              ideas for new or improved products or technologies, websites or tool enhancements, processes,
              materials, marketing plans or new product names. We are under no obligation to review or
              consider them. If you choose to submit any ideas, original creative artwork, suggestions or
              other works (&quot;<strong>Submissions</strong>&quot;) in any form to us,
              then regardless of what you say, write or provide to us in connection with your submissions,
              the following terms shall apply.
              The sole purpose of this policy is to avoid potential misunderstandings or disputes in the
              event that any part of our business, such as our products, websites, technologies or marketing
              strategies, seems similar to any of your submissions. If you provide any submissions to us,
              you agree that:
              (i) your submission and its contents will automatically become the property of MSI,
              without any compensation to you;
              (ii) MSI may use or redistribute any such submission and its contents for any purpose and in
              any way; (iii) there is no obligation for MSI to review any submission; and
              (iv) there is no obligation to keep any submission confidential.
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">16.</span>Links to Third-Party Products and Websites.</strong></p>

            <p>This Product may contain links and pointers to other Internet websites, products resources and sponsors.
              Links to and from the Product to other third-party Products, maintained by third parties, do not constitute
              an endorsement by us of any third parties, the third-party products or the contents thereof.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">17.</span>Legal Compliance; Representations and Warranties.</strong></p>

            <p>You agree to be responsible for, and agree to abide by, all laws, rules and regulations applicable to the services you provide,
              and your use of the service or Product offered. You further agree that you are responsible for and agree to abide by all laws, rules,
              ordinances, or regulations applicable to conduct of your real estate business, including but not limited to any and all laws, rules,
              ordinances, regulations or other requirements relating to taxes, data and privacy, license requirements, and compliance with all
              anti-discrimination and fair housing laws, as applicable. Please be aware that, even though we are not a party to any transaction,
              there may be circumstances where we are nevertheless legally obligated (as we may determine in our sole discretion) to provide information
              related to your services in order to comply with requests from governmental bodies in relation to investigations, litigation or administrative
              proceedings, and we may choose to comply with such obligations in our sole discretion.</p>

            <p>
              For the duration of the term of the agreement between you and MSI, you and your Agents must
              hold all of the licenses that are required by the state your real estate brokerage business is
              located in, including without limitation licenses to act as real estate brokers and real estate agents
              as applicable.  You and your Agents will comply with all applicable laws and regulations in
              performing its services, including without limitation the limits and restrictions on payments
              for referrals for other real estate settlement services.
            </p>

            <p>
              You represent and warrant that the execution, delivery and performance by you under these Terms
              and the applicable agreement with MSI will not violate any law, statute or other governmental
              regulation and that it is in compliance and will continue to comply with during the term of the agreement
              all relevant local, state and federal requirements. You warrant that your brokerage will maintain
              sufficient insurance coverage to enable it to meet its obligations created by this Agreement and by law.
            </p>

            <p>You represent, acknowledge, and agree that you have read and understand the Real Estate Settlement Procedures Act, 12 U.S.C. § 2601 et seq.,
              and its implementing regulations, 12 CFR § 1024.1 et seq. (collectively, “RESPA”) and all other applicable laws and regulations relating to these
              Terms and your performance hereunder. You agree to comply with the limitations set forth in RESPA and all other applicable laws when performing
              services under these Terms.</p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">18.</span>Limitation of Liability.</strong></p>

            <p>
              <strong>
                IN NO EVENT WILL MSI, OR ITS SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS, CONSULTANTS, AGENTS AND/OR EMPLOYEES
                (COLLECTIVELY, THE “MSI GROUP”), OR ANY THIRD-PARTY PROVIDER OF A SERVICE OR TOOL OFFERED ON ANY PRODUCT OF A MEMBER OF THE
                MSI GROUP (EACH A “THIRD-PARTY PROVIDER”), BE LIABLE FOR ANY LOST PROFITS OR ANY INDIRECT, CONSEQUENTIAL, SPECIAL, INCIDENTAL,
                OR PUNITIVE DAMAGES ARISING OUT OF, BASED ON, OR RESULTING FROM (A) OUR PRODUCT, (B) THESE TERMS, (C) ANY BREACH OF THESE TERMS
                BY YOU OR A THIRD PARTY, OR (D) USE OF THE PRODUCT, TOOLS OR SERVICES WE PROVIDE, OR ANY THIRD PARTY PROVIDER PROVIDES, RELATED
                TO THE BUSINESS WE OPERATE ON THE PRODUCT, BY YOU OR ANY THIRD PARTY. THESE LIMITATIONS AND EXCLUSIONS APPLY WITHOUT REGARD TO
                WHETHER THE DAMAGES ARISE FROM (1) BREACH OF CONTRACT, (2) BREACH OF WARRANTY, (3) STRICT LIABILITY, (4) TORT, (5) NEGLIGENCE,
                OR (6) ANY OTHER CAUSE OF ACTION, TO THE MAXIMUM EXTENT SUCH EXCLUSION AND LIMITATIONS ARE NOT PROHIBITED BY APPLICABLE LAW.
              </strong>
            </p>

            <p>
              <strong>
                IF YOU ARE DISSATISFIED WITH THE PRODUCT, YOU DO NOT AGREE WITH ANY PART OF THE TERMS OR HAVE ANY OTHER DISPUTE OR
                CLAIM WITH OR AGAINST US, ANY THIRD-PARTY PROVIDER OR ANY USER OF THE PRODUCT WITH RESPECT TO THESE TERMS OR THE PRODUCT,
                THEN YOUR SOLE AND EXCLUSIVE REMEDY AGAINST US IS TO DISCONTINUE USING THE PRODUCT. IN ALL EVENTS, OUR LIABILITY, AND THE
                LIABILITY OF ANY MEMBER OF THE MSI GROUP, TO YOU OR ANY THIRD PARTY IN ANY CIRCUMSTANCE ARISING OUT OF OR IN CONNECTION
                WITH THE PRODUCT IS LIMITED TO THE GREATER OF (A) THE AMOUNT OF FEES YOU PAY TO US IN THE TWELVE MONTHS PRIOR TO THE ACTION
                GIVING RISE TO LIABILITY OR (B) $100.00 IN THE AGGREGATE FOR ALL CLAIMS.
              </strong>
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">19.</span>Disclaimers.</strong></p>

            <p><strong>THE PRODUCT, INCLUDING ALL CONTENT, SOFTWARE, FUNCTIONS, MATERIALS AND INFORMATION MADE AVAILABLE ON OR ACCESSED
              THROUGH THE PRODUCT, IS PROVIDED "AS IS." TO THE FULLEST EXTENT PERMISSIBLE BY LAW, WE MAKE NO REPRESENTATIONS OR WARRANTIES
              OF ANY KIND WHATSOEVER FOR THE CONTENT ON THE PRODUCT OR THE MATERIALS, INFORMATION AND FUNCTIONS MADE ACCESSIBLE BY THE
              SOFTWARE USED ON OR ACCESSED THROUGH THE PRODUCT, FOR ANY PRODUCTS OR SERVICES OR HYPERTEXT LINKS TO THIRD PARTIES OR FOR
              ANY BREACH OF SECURITY ASSOCIATED WITH THE TRANSMISSION OF SENSITIVE INFORMATION THROUGH THE PRODUCT OR ANY LINKED PRODUCT,
              EVEN IF WE BECOME AWARE OF ANY SUCH BREACHES. FURTHER, WE EXPRESSLY DISCLAIM ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
              WITHOUT LIMITATION, NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR ACCURACY. WE DO NOT WARRANT THAT
              THE FUNCTIONS CONTAINED ON THE PRODUCT OR ANY MATERIALS OR CONTENT CONTAINED THEREIN WILL BE UNINTERRUPTED OR ERROR FREE,
              THAT DEFECTS WILL BE CORRECTED, OR THAT THE PRODUCT OR THE SERVER THAT MAKES IT AVAILABLE IS FREE OF VIRUSES OR OTHER HARMFUL
              COMPONENTS. YOU ACKNOWLEDGE AND AGREE THAT ANY TRANSMISSION TO AND FROM THIS PRODUCT IS NOT CONFIDENTIAL AND YOUR COMMUNICATIONS
              OR USER-CONTRIBUTED CONTENT MAY BE READ OR INTERCEPTED BY OTHERS. YOU FURTHER ACKNOWLEDGE AND AGREE THAT BY SUBMITTING
              COMMUNICATIONS OR USER-CONTRIBUTED CONTENT TO US AND BY POSTING INFORMATION ON THE PRODUCT, INCLUDING PROPERTY LISTINGS,
              NO CONFIDENTIAL, FIDUCIARY, CONTRACTUALLY IMPLIED OR OTHER RELATIONSHIP IS CREATED BETWEEN YOU AND US OTHER THAN PURSUANT TO THESE TERMS.</strong></p>

            <p><strong>YOU ACKNOWLEDGE AND AGREE THAT YOU WILL NOT HOLD OR SEEK TO HOLD US OR ANY THIRD-PARTY PROVIDER RESPONSIBLE FOR
              THE CONTENT PROVIDED BY ANY USER, INCLUDING, WITHOUT LIMITATION, ANY TRANSLATION THEREOF, AND YOU FURTHER ACKNOWLEDGE AND
              AGREE THAT WE ARE NOT A PARTY TO ANY REAL ESTATE TRANSACTION OR OTHER TRANSACTION BETWEEN USERS OF THE PRODUCT.</strong></p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">20.</span>Release; Indemnification.</strong></p>

            <p>
              <strong>
                IN THE EVENT THAT YOU HAVE A DISPUTE WITH ONE OR MORE OTHER USERS OF THE PRODUCT (INCLUDING, WITHOUT LIMITATION,
                ANY DISPUTE BETWEEN USERS REGARDING ANY TRANSACTION OR USER-CONTRIBUTED CONTENT) OR ANY THIRD PARTY PROVIDER OR ANY THIRD
                PARTY WEBPRODUCT THAT MAY BE LINKED TO OR FROM OR OTHERWISE INTERACT WITH THE PRODUCT, YOU HEREBY AGREE TO RELEASE, REMISE
                AND FOREVER DISCHARGE EACH MEMBER OF THE MSI GROUP, EACH OF THEIR RESPECTIVE AGENTS, DIRECTORS, OFFICERS, EMPLOYEES,
                AND ALL OTHER RELATED PERSONS OR ENTITIES FROM ANY AND ALL MANNER OF RIGHTS, CLAIMS, COMPLAINTS, DEMANDS, CAUSES OF ACTION,
                PROCEEDINGS, LIABILITIES, OBLIGATIONS, LEGAL FEES, COSTS, AND DISBURSEMENTS OF ANY NATURE WHATSOEVER, WHETHER KNOWN OR UNKNOWN,
                WHICH NOW OR HEREAFTER ARISE FROM, RELATE TO, OR ARE CONNECTED WITH SUCH DISPUTE AND/OR YOUR USE OF THE PRODUCT.
                <br />IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE SECTION 1542, WHICH SAYS: &quot;A GENERAL RELEASE DOES NOT
                EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH,
                IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR.&quot;
              </strong>
            </p>

            <p>
              <strong>
                YOU HEREBY AGREE TO INDEMNIFY, DEFEND AND HOLD EACH MEMBER OF THE MSI GROUP (COLLECTIVELY, THE "INDEMNIFIED PARTIES")
                HARMLESS FROM AND AGAINST ANY AND ALL LIABILITY AND COSTS INCURRED BY THE INDEMNIFIED PARTIES IN CONNECTION WITH ANY CLAIM ARISING
                OUT OF YOUR USE OF THE PRODUCT OR OTHERWISE RELATING TO THE BUSINESS WE CONDUCT ON THE PRODUCT (INCLUDING, WITHOUT LIMITATION,
                ANY POTENTIAL OR ACTUAL COMMUNICATION, TRANSACTION OR DISPUTE BETWEEN YOU AND ANY OTHER USER OR THIRD PARTY), ANY CONTENT POSTED
                BY YOU OR ON YOUR BEHALF OR POSTED BY OTHER USERS OF YOUR ACCOUNT TO THE PRODUCT, ANY USE OF ANY TOOL OR SERVICE PROVIDED BY A
                THIRD PARTY PROVIDER, ANY USE OF A TOOL OR SERVICE OFFERED BY US THAT INTERACTS WITH A THIRD PARTY WEBPRODUCT, OR ANY BREACH BY
                YOU OF THESE TERMS OR THE REPRESENTATIONS, WARRANTIES AND COVENANTS MADE BY YOU HEREIN, INCLUDING WITHOUT LIMITATION, ATTORNEYS'
                FEES AND COSTS. YOU SHALL COOPERATE AS FULLY AS REASONABLY REQUIRED IN THE DEFENSE OF ANY CLAIM.
              </strong>
            </p>

            <p><strong>WE RESERVE THE RIGHT, AT OUR OWN EXPENSE, TO ASSUME THE EXCLUSIVE DEFENSE AND CONTROL OF ANY MATTER OTHERWISE SUBJECT
              TO INDEMNIFICATION BY YOU AND YOU SHALL NOT IN ANY EVENT SETTLE ANY MATTER WITHOUT OUR WRITTEN CONSENT.</strong></p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">21.</span>Disputes; Arbitration.</strong></p>

            <p>
              MSI’s right to amend these Terms, in whole or in part, at any time as set forth below does not
              apply to this "Disputes; Arbitration" section. The version of this “Disputes; Arbitration” section
              in effect on the date you last accepted the Terms by interacting with the platform or realtor.com controls.
              MSI is committed to customer satisfaction, so if you have a problem or dispute, we will try
              to resolve your concerns. But if we are unsuccessful, you may pursue claims as explained in this section.
              You agree to give us an opportunity to resolve any disputes or claims relating in any way to the Product, any dealings
              with our customer experience agents, any services or products provided, any representations made by us, or
              our <a href={this.state.privacyPolicyLink} target="_newtab">Privacy Policy</a>, (&quot;<strong>Claims</strong>&quot;) by contacting us.
              If we are not able to resolve your Claims within 60 days, you may seek relief through arbitration or in small claims court, as set forth below.
            </p>

            <p>
              <strong>
                Any and all Claims will be resolved by binding arbitration, rather than in court, except you may assert Claims on an
                individual basis in small claims court if they qualify. This includes any Claims you assert against us, our subsidiaries,
                users or any companies offering products or services through us (which are beneficiaries of this arbitration agreement).
                This also includes any Claims that arose before you accepted these Terms, regardless of whether prior versions of the Terms required arbitration.
              </strong>
            </p>

            <p><strong>There is no judge or jury in arbitration, and court review of an arbitration award is limited. However, an arbitrator
              can award on an individual basis the same damages and relief as a court (including statutory damages, attorneys’ fees and costs),
              and must follow and enforce these Terms as a court would.</strong></p>

            <p>
              <strong>
                Arbitrations will be conducted by the American Arbitration Association (AAA) under its rules, including the AAA
                Arbitration Consumer Rules (together, the &quot;AAA Rules&quot;). Payment of all filing, administration and arbitrator fees
                will be governed by the AAA's rules, except as provided in this section. If your total Claims seek less than $10,000,
                we will reimburse you for filing fees you pay to the AAA and will pay arbitrator’s fees. You may choose to have an arbitration
                conducted by telephone, based on written submissions, or in person in the state where you live or at another mutually agreed upon location.
              </strong>
            </p>

            <p>
              <strong>
                By agreeing to arbitration under the AAA Rules, the parties agree, among other things, that the arbitrator, and not any federal,
                state, or local court or agency, shall have the exclusive power to rule on any objections with respect to the existence, scope,
                or validity of the arbitration agreement or to the arbitrability of any claim or counterclaim
              </strong>
            </p>

            <p>
              <strong>
                To begin an arbitration proceeding, you must send a letter requesting arbitration and
                describing your Claims to “MSI Legal,” at Move Sales, Inc., 901 East 6th St., Suite 500, Austin, TX 78702.
                If we request arbitration against you, we will give you notice at the email address or street
                address you have provided. The AAA&apos;s rules and filing instructions are available at www.adr.org
                or by calling 1-800-778-7879.
              </strong>
            </p>

            <p>
              <strong>
                Any and all proceedings to resolve Claims will be conducted only on an individual basis and not in a class,
                consolidated or representative action. If for any reason a Claim proceeds in court rather than in
                arbitration we each waive any right to a jury trial.
                The Federal Arbitration Act and federal arbitration law apply to these Terms.
                An arbitration decision may be confirmed by any court with competent jurisdiction.
              </strong>
            </p>

            <p><strong><span className="BrokerTermsAndConditions__ordered-list">22.</span>GENERAL</strong></p>

            <p>
              To Contact Us for any reason, users can visit www.realtor.com.
            </p>

            <p>
              Sections 2, 4, 10-22 will survive any termination of the agreement between you and
              MSI.
              <strong>
                You and Agent affirm that the payment obligations set forth in Section 10 shall survive any
                termination of the agreement between you and MSI and shall continue until the expiration of
                any applicable Referral Coverage Period.
              </strong>
            </p>

            <p>These Terms are governed by the Federal Arbitration Act, 9 U.S.C. § 1 et seq. (&quot;<strong>FAA</strong>&quot;), AAA Rules, federal arbitration law,
              and for U.S. residents, the laws of the state in which you reside (as determined by the billing address you have provided us),
              without regard to conflict of laws principles. It is the intent of the parties that the FAA and AAA Rules shall preempt all
              state laws to the fullest extent permitted by law.</p>

            <p>
              Our relationship is that of independent contractors, and no agency, partnership, joint venture,
              employee-employer or franchiser-franchisee relations is intended or created by these Terms or
              your use of the Product. You are required to pay all applicable taxes including federal and state
              income tax on any fees that are paid to you by a Referral. You are also responsible for all expenses
              and payments related to activities detailed within these Terms including compensating your Agents.
              You are also responsible for any associated sales taxes related to your participation with this
              Product and receipt of referrals.
            </p>

            <p>
              Except as explicitly stated otherwise, any notices to us shall be given by postal mail to: Move
              Sales, Inc., Attn: Legal Department, 901 East 6th St., Suite 500, Austin, TX 78702. When we need
              to send you notice, it will be sent to the email address you provide in the Product during the
              registration process or as later updated in your account (if applicable). Notice shall be deemed
              given upon receipt or 24 hours after an email is sent, unless the sending party is notified that
              the email address is invalid. Alternatively, we may give you notice by certified mail, postage
              prepaid and return receipt requested, to any physical address provided to us during the registration
              process or as later updated in your account (if applicable). Notice shall be deemed given three
              days after the date of mailing to a physical address and one day after mailing to an electronic address.
            </p>

            <p>We may change, suspend or discontinue any aspect of the Product at any time, including the availability of any Product features,
              database or content. We may also impose limits on certain features or services or restrict your access to parts or the entire
              Product without notice or liability. This version of the Terms became effective on the date set forth above and this version amends
              the version effective before such date. We reserve the right, in our sole discretion, to amend these Terms, in whole or in part, at any time.
              Notification of any amendment will be posted on the Product by the indication of the last amendment date at the top of these Terms and
              will be effective immediately. When users renew subscriptions, the terms in effect at the time of renewal will govern, provided that
              such terms may change as described above.</p>

            <p>We also reserve the right, in our sole discretion and from time to time, to offer programs, products or services with unique terms and
              conditions that are separate from and may supersede or supplement in certain respects these Terms. In such cases, your use of the Product
              with respect to such special program is governed by these Terms together with the terms and conditions of such program, product or service.
              We reserve the right, but assume no obligation, to agree to different or conflicting terms and conditions with respect to any user.
              Any such terms and conditions will not be enforceable unless specifically agreed to by us.</p>

            <p>We do not separately file the Terms entered into by each user of the Product. Please make a copy of these Terms for your records by printing
              and/or saving a downloaded copy of the Terms on your personal computer. We may immediately terminate any user’s access to or use of the Product
              due to such user’s breach of these Terms or any other unauthorized use of the Product. However, we do not guarantee that we will take action
              against all breaches of these Terms. Our failure to take immediate action with respect to a breach by you or others does not waive our right
              to act with respect to such breach or any other breach.</p>

            <p>No waiver of any term, condition or obligation of these Terms will be valid unless made in writing and signed by the party to which such
              performance is due.  No failure or delay by any party at any time to enforce one or more requirements under these Terms will (a)
              constitute waiver of such requirement (or any subsequent requirement) or (b) preclude such party from requiring performance by the other party
              of such requirement at any later time. In the event any provision of these Terms is held by a court or other tribunal of competent jurisdiction
              to be unenforceable, that provision will be enforced to the maximum extent permissible under applicable law, and the other provisions of these
              Terms will remain in full force and effect. The parties further agree that in the event such provision is an essential part of these Terms,
              they will begin negotiations for a suitable replacement provision.</p>

            <p>These Terms constitute the entire agreement between us and you with respect to the matters set forth herein and supersede any prior agreement
              between us and you with respect to your use of the Product. Headings in these Terms are for reference only and do not limit the scope or extent
              of such section. In the event of any conflict between these Terms and any other terms and conditions applicable to a product, tool or service
              offered on our Product, the Terms herein shall prevail. If any portion of these Terms is found to be invalid or unenforceable by any court of
              competent jurisdiction, the other provisions of these Terms shall remain in full force and effect. Further, any provision of these Terms held
              invalid or unenforceable only in part or degree will remain in full force and effect to the extent not held invalid or unenforceable.</p>

            <p>We may assign these Terms in our sole discretion. Users must obtain our prior written consent to assign these Terms, which may be granted
              or withheld by us in our sole discretion.</p>
          </div>
        </div>
      </div>
    )
  }
}
